// extracted by mini-css-extract-plugin
module.exports =  {"root":"Y5zg0sdghcWwBTK2rtuA"};